export const manufacturerSelectConfig = {
    rowKey: "id",
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 100,
            sorter: true,
        },
        {
            title: "Название",
            dataIndex: "name",
            key: "name",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Контактное лицо",
            dataIndex: "contactPerson",
            key: "contactPerson",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Телефон",
            dataIndex: "contactPhone",
            key: "contactPhone",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Email",
            dataIndex: "contactEmail",
            key: "contactEmail",
            sorter: true,
            ellipsis: true,
        },
    ],
};
